module.exports = __webpack_public_path__ + "img/access-based-enumeration.0473b674.png";